import { render } from "./App.vue?vue&type=template&id=552108b8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=552108b8&lang=css"
script.render = render

export default script